module.exports = __webpack_public_path__ + "static/media/fireIcon.61e88a33.svg";